import { DISPUTE_DETAIL, DISPUTE_DETAIL_FAILURE, DISPUTE_DETAIL_SUCCESS, EXPORT_DISPUTES, EXPORT_DISPUTES_FAILURE, EXPORT_DISPUTES_SUCCESS, GET_DISPUTES, GET_DISPUTES_FAILURE, GET_DISPUTES_SUCCESS } from "../constants";

const initialState = {
    isLoading: false,
    allDisputes: [],
    disputeDetail: {}
}

export default function DisputeReducer(state = initialState, action) {
    switch (action.type) {
        case GET_DISPUTES:
            state = {
                ...state,
                isLoading: true,
                allDisputes: [],
            };
            break;
        case GET_DISPUTES_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                allDisputes: action.payload,
            };
            break;
        case GET_DISPUTES_FAILURE:
            state = {
                ...state,
                isLoading: false,
                allDisputes: [],
            };
            break;
        case EXPORT_DISPUTES:
            state = {
                ...state,
            };
            break;
        case EXPORT_DISPUTES_SUCCESS:
            state = {
                ...state,
            };
            break;
        case EXPORT_DISPUTES_FAILURE:
            state = {
                ...state,
            };
            break;
        case DISPUTE_DETAIL:
            state = {
                ...state,
                isLoading: true,
                disputeDetail: {}
            };
            break;
        case DISPUTE_DETAIL_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                disputeDetail: action.payload
            };
            break;
        case DISPUTE_DETAIL_FAILURE:
            state = {
                ...state,
                isLoading: false,
                disputeDetail: {}
            };
            break;
        default:
            break;
    }
    return state

}